function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.118 33.776c.34 0 .615.283.615.633v3.621c0 .35-.275.634-.615.634a.624.624 0 01-.614-.634v-3.62c0-.35.275-.634.614-.634z",
  fill: "#2D2D2D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.415 3.287A1.36 1.36 0 0116.247 3h29.337C46.391 3 47 3.695 47 4.495v29.729c0 .434-.18.852-.5 1.139l-4.288 3.85-.006.005c-.034.03-.101.091-.189.145a1.13 1.13 0 01-.33.137c-.216.053-.5.069-.9.069h-11.96a.624.624 0 01-.614-.634c0-.35.276-.633.615-.633h11.958c.381 0 .54-.018.605-.032l.014-.013 4.289-3.85a.247.247 0 00.077-.183V4.494c0-.15-.108-.227-.186-.227H16.248a.155.155 0 00-.095.034l-.003.002-5.054 3.885a.246.246 0 00-.089.194v8.377c0 .35-.275.633-.614.633a.624.624 0 01-.615-.633V8.382c0-.471.212-.923.58-1.208h.002l5.055-3.887z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.778 8.16c0-.35.275-.634.615-.634h29.931c.819 0 1.409.713 1.409 1.523v16.309c0 .35-.276.633-.615.633a.624.624 0 01-.614-.633V9.049a.299.299 0 00-.069-.203.147.147 0 00-.11-.053H10.392a.624.624 0 01-.615-.634z",
  fill: "#2D2D2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.942 3.186c.24.247.24.648 0 .896l-4.39 4.526a.601.601 0 01-.868 0 .648.648 0 010-.897l4.39-4.525a.601.601 0 01.868 0zM41.118 27.44c.34 0 .615.283.615.633v3.62c0 .35-.275.634-.615.634a.624.624 0 01-.614-.633v-3.62c0-.35.275-.635.614-.635zM13.29 44.367c0-.35.275-.634.615-.634h21.302c.34 0 .615.284.615.634 0 .35-.275.633-.615.633H13.904a.624.624 0 01-.614-.633zM36.992 44.367c0-.35.275-.634.615-.634h1.638c.34 0 .615.284.615.634 0 .35-.275.633-.615.633h-1.638a.624.624 0 01-.615-.633zM2.392 17.836c-.063 0-.163.064-.163.207v18.144a.234.234 0 00.058.157l3.431 3.71c.034.036.073.05.106.05H28.05c.064 0 .164-.065.164-.207V21.838a.223.223 0 00-.08-.177l-4.915-3.794-.003-.002a.129.129 0 00-.08-.029H2.392zM1 18.043c0-.785.596-1.474 1.392-1.474h20.744a1.333 1.333 0 01.822.286l4.912 3.791c.365.282.573.727.573 1.192v18.059c0 .785-.597 1.474-1.393 1.474H5.824c-.378 0-.735-.163-.994-.442l-3.434-3.712A1.522 1.522 0 011 36.187V18.043z",
  fill: "#2D2D2D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.389 22.634c0-.789.575-1.539 1.409-1.539h22.03c.339 0 .614.284.614.634 0 .35-.275.634-.614.634H6.798c-.029 0-.067.011-.106.056a.325.325 0 00-.074.215v6.336c0 .35-.275.634-.615.634a.624.624 0 01-.614-.634v-6.336z",
  fill: "#2D2D2D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.369 17.35a.602.602 0 01.869.004l4.08 4.25a.648.648 0 01-.005.896.602.602 0 01-.87-.004l-4.079-4.25a.648.648 0 01.005-.897zM6.003 35.578c.34 0 .615.283.615.633v1.69c0 .35-.275.633-.615.633a.624.624 0 01-.614-.633v-1.69c0-.35.275-.633.614-.633zM6.003 31.052c.34 0 .615.284.615.634v1.69c0 .35-.275.633-.615.633a.624.624 0 01-.614-.634v-1.69c0-.35.275-.633.614-.633zM16.802 32.39c0-.74.58-1.338 1.297-1.338h7.413c.717 0 1.297.599 1.297 1.338v4.023c0 .738-.58 1.337-1.297 1.337H18.1c-.716 0-1.297-.599-1.297-1.337V32.39zm1.297-.07a.07.07 0 00-.068.07v4.023c0 .038.03.07.068.07h7.413a.07.07 0 00.068-.07V32.39a.07.07 0 00-.068-.07H18.1zM28.214 12.484c0-.739.58-1.337 1.297-1.337h7.413c.717 0 1.297.599 1.297 1.337v4.023c0 .74-.58 1.338-1.297 1.338h-7.413c-.716 0-1.297-.599-1.297-1.338v-4.023zm1.297-.07a.07.07 0 00-.068.07v4.023c0 .04.03.07.068.07h7.413a.07.07 0 00.069-.07v-4.023a.07.07 0 00-.069-.07h-7.413z",
  fill: "#2D2D2D"
});

function SvgBoxes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "/img/boxes.svg";
export { SvgBoxes as ReactComponent };